import { FEATURE_FLAGS } from '../../../featureFlags';
import ProjectsList from './ProjectsList.vue';
import ProjectDetails from './ProjectDetails.vue';
import PlaybooksList from './PlaybooksList.vue';
import PlaybookEditor from './PlaybookEditor.vue';

const commonMeta = {
  featureFlag: FEATURE_FLAGS.PROJECTS,
  permissions: ['administrator', 'agent'],
};

export const routes = [
  {
    path: 'projects',
    name: 'projects_list',
    component: ProjectsList,
    meta: commonMeta,
  },
  {
    path: 'projects/:projectId(\\d+)',
    name: 'project_details',
    component: ProjectDetails,
    meta: commonMeta,
    props: route => ({ projectId: route.params.projectId }),
  },
  {
    path: 'playbooks',
    name: 'playbooks_list',
    component: PlaybooksList,
    meta: commonMeta,
  },
  {
    path: 'playbooks/:playbookId(\\d+)',
    name: 'playbook_editor',
    component: PlaybookEditor,
    meta: commonMeta,
    props: route => ({ playbookId: route.params.playbookId }),
  },
];

export default routes;
